import React from "react";
import SegmentToggle from "./SegmentToggle";

const PARTY_OPTIONS = [
  {
    value: "CUSTOMER",
    label: "Customer",
    activeClass: "bg-main text-white shadow-sm ring-1 ring-main/20",
  },
  {
    value: "GUEST",
    label: "Guest",
    activeClass: "bg-warning text-white shadow-soft ring-1 ring-warning/30",
  },
];

const InvoiceCustomerType = ({
  customerType,
  setCustomerType,
  label = "Sale to",
}) => (
  <SegmentToggle
    label={label}
    options={PARTY_OPTIONS}
    value={customerType}
    onChange={setCustomerType}
  />
);

export default InvoiceCustomerType;
